module.exports = __webpack_public_path__ + "img/noGroup.23aeadc8.svg";